/*
 * @Author: bbqin
 * @Date: 2022-10-20 13:36:52
 * @LastEditTime: 2022-10-25 11:05:09
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\dnd\container.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import DragItem from './Item';
import { ItemTypes } from './ItemTypes';

const spec = {
    drop(props, monitor, component) {
        // 这里 return 出去的对象属性自行选择，这里只是用 id 作为演示
        return { id: props.id };
    },
    hover(props, monitor, component) {

    },
};

const collect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDropTarget: connect.dropTarget(),
});

@DropTarget(ItemTypes.ITEM, spec, collect)
class Container extends Component {
    constructor(props) {
        super(props);
        this.state = { data: props.data };
    }
    /**
     * 修改排序
     * @param {Number} dragIndex 拖拽的对象的index值
     * @param {Number} hoverIndex 拖拽结束或鼠标悬浮的对象的index值
     **/
    moveItem = (dragIndex, hoverIndex) => {
        let { data: newData, onDragEnd } = this.props;

        console.log("拖拽排序之前的数据", newData);
        const dragItem = newData[dragIndex];
        newData.splice(dragIndex, 1);
        newData.splice(hoverIndex, 0, dragItem);
        console.log("拖拽排序之后的数据", newData, dragIndex, hoverIndex);

        this.setState({ data: newData }, () => {
            onDragEnd && onDragEnd(newData, dragItem, hoverIndex);
        });
    };

    render() {

        const { data, getList, getListItem, onStop } = this.props;

        return (
            <div
                className="setting-dnd-list"
            >
                {getList ?
                    getList(DragItem, data, (...params) => {
                        this.moveItem.call(this, ...params);
                    })
                    : data.map((item, index) => {
                        const { attrcode, islock, className } = item;
                        return <DragItem
                            key={attrcode}
                            id={attrcode}
                            index={index}
                            draggable={!islock}
                            droppable={!islock}
                            moveItem={this.moveItem}
                            onStop={onStop}
                            className={className}
                        > {getListItem(item, index)}</DragItem>;
                    })}
            </div>
        );
    }
}
export default Container;